import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { UserService } from '../../../shared/user.service';
import { HttpClient } from '@angular/common/http';
import { AssetCardDetails } from 'src/app/models/assetCardDetails';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { User } from 'src/app/models/user';
import { Location } from '@angular/common';
import { read } from 'fs';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {


  tempSkillArr: Array<string> = [];
  skillsArray: Array<string> = [""];
  targetUserEmaiId: string = '';
  targetUser: User;
  assetsCardDetails: Array<AssetCardDetails> = [];
  selectedTab: string;
  aboutUser: string = '';
  aboutUserTxt: string = '';
  admiredTabFlgDisable: boolean = false;
  allModelTabDisable: boolean = false;
  selfProfileFlg: boolean = true;
  spinnerFlg: boolean;
  editClickedFlg: boolean = false;
  userSkillText: string = '';
  editSkillClickedFlg: boolean = false;
  //  set the default path of profile image duirng the page load
  userProfileImageURL: string = 'assets/img/userDefault.png';
  fileUpload: File = null;
  isProfileImageEdit: boolean = false;
  isProfileImageDelete: boolean = false;
  showSuccessMessage: string;
  showFailureMessage: string;
  isShowNotificationSuccess: boolean = false;
  isShowNotificationFailure: boolean = false;
  isDisableUploadButton: boolean = true;
  noEdits: boolean = false;
  isShowNotificationAlert: boolean;
  showAlertMessage: string;
  //  userProfileImage: string;
  // tempStr:string;
  // aboutUserEditedTxt:string='';
  // aboutUserUpdateFlag:boolean=false;
  constructor(private http: HttpClient, private httpService: HttpService, private userService: UserService, private activeRoute: ActivatedRoute, private location: Location, private router: Router) {
    //Getting the userEmailId from Route parameter
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.activeRoute.params.subscribe(
      (param: Params) => {
        this.targetUserEmaiId = param['userEmailId'];
      });
  }

  ngOnInit() {
    this.httpService.getBasePath().then(res => {
      this.fetchUserProfileImage(this.targetUserEmaiId);
    }, err => { console.log(err) });
    //On page load the Admired model tab is clicked by default
    this.onTabClick('admired');
    if (this.targetUserEmaiId !== this.userService.loggendInUser.userEmailId) {
      console.log("user mismatch");
      console.log(this.targetUser);
      this.noEdits = true;
    }
  }
  /**
   * It will decide which tab the user has selected and accordingly call its method
   * @param selectedTab it stores the selected tab's name(Admired/All/Subscibed Models) 
   */
  onTabClick(selectedTab: string) {
    //When the Admired Model tab is clicked
    if (selectedTab === 'admired') {
      this.selectedTab = selectedTab;
      this.getHighRatedAsset();
    }
    //When the All Uploaded Model tab is clicked
    else if (selectedTab === 'all') {
      this.selectedTab = selectedTab;
      this.getAllUploadedAsset();
    }
    //When the All Subscribed Model tab is clicked
    else if (selectedTab === 'subscribed') {
      this.selectedTab = selectedTab;
      this.getAllSubscribedAsset();
    }

  }
  /**
   * Api to fetch all the high rated asset is called
   */

  currentUserCheck(): boolean {
    return this.noEdits;
  }

  getHighRatedAsset() {

    this.assetsCardDetails = [];
    this.spinnerFlg = true;
    this.httpService.getBasePath().then(
      (res) => {

        this.userService.getHighRatedAsset(this.targetUserEmaiId).subscribe(
          (response: any) => {
            this.assetsCardDetails = response.item1;
            this.targetUser = response.item2;
            console.log(this.targetUser);
            this.applyUserRestriction();
            this.setUserInfo();
            this.spinnerFlg = false;
          },
          (err) => {
            alert(`This user seems to be a primary contact and may not exist in VAL, so you will be redirected to the uploader's profile-${this.httpService.uploader}@siemens-healthineers.com`);
            this.targetUserEmaiId = `${this.httpService.uploader}@siemens-healthineers.com`;
            this.location.go(`/val-assets/userProfile/${this.targetUserEmaiId}`);
            this.onTabClick('admired');
            console.log(err);
            this.spinnerFlg = false;
          }
        );
      }, (err) => {
        console.log(err);
        this.spinnerFlg = false;
      });

  }
  /**
   * Api to fetch all the uploaded asset is called
   */
  getAllUploadedAsset() {
    this.assetsCardDetails = [];
    this.spinnerFlg = true;
    this.userService.getAllUploadedAsset(this.targetUserEmaiId).subscribe(
      (response: Array<AssetCardDetails>) => {
        this.assetsCardDetails = response;
        this.spinnerFlg = false;
      },
      (err) => {
        console.log(err);
        this.spinnerFlg = false;
      });
  }

  getAllSubscribedAsset() {
    this.assetsCardDetails = [];
  }
  /**
   * Disable the tabs according to the user restriction settings
   */
  applyUserRestriction() {
    // Apply the settings only if loggedin user and the target user are not same 
    if (this.targetUserEmaiId !== this.userService.loggendInUser.userEmailId) {
      this.selfProfileFlg = false;
      if (this.targetUser.userSettings.userRestriction != null) {
        this.allModelTabDisable = this.targetUser.userSettings.userRestriction.allModels ? true : false;
        this.admiredTabFlgDisable = this.targetUser.userSettings.userRestriction.summary ? true : false;
        if (this.admiredTabFlgDisable == true) {
          this.assetsCardDetails = [];
        }

      }


    }
  }

  /**
   * Set the user's about and skills
   */
  setUserInfo() {

    this.aboutUser = this.targetUser.aboutMe != null ? this.targetUser.aboutMe : '';
    this.skillsArray = this.targetUser.skills.length > 0 ? this.targetUser.skills : [""];
  }
  /**
   * 
   * @param aboutTxt User's input in the about user text
   */
  updateUsersAbout(aboutTxt: string) {
    if (this.aboutUser === aboutTxt) {
      // alert("You did not do any modification.");
      this.alertNotification('You did not do any modification.');
      return;
    }
    let requestParam: object = {};
    requestParam = {
      "UserEmailId": this.targetUserEmaiId,
      "AboutMe": this.aboutUserTxt.trim(),
      "Websites": [],
      "Skills": this.skillsArray
    };
    //calling the user profile update API
    this.callUpdateUserInfoApi(requestParam);

  }

  /**
   * This is called when the update button of skills is clicked
   */
  saveSkills(skillTxt: string) {
    if (this.skillsArray[0] == skillTxt) {
      // alert("You did not do any modification.");
      this.alertNotification('You did not do any modification');
      return;
    }
    let requestParam: object = {};
    requestParam = {
      "UserEmailId": this.targetUserEmaiId,
      "AboutMe": this.targetUser.aboutMe,
      "Websites": [],
      "Skills": [this.userSkillText]
    };
    this.callUpdateUserInfoApi(requestParam);
  }
  /**
   * Update user api call
   * @param requestParam the request object to be send to the api
   */
  callUpdateUserInfoApi(requestParam: object) {

    this.userService.updateUserInfo(requestParam).subscribe(
      (res) => {
        this.onTabClick('admired');
        this.editClickedFlg = false;
        this.editSkillClickedFlg = false;
        // alert('Updated Successfully');
        this.successNotification('Updated Successfully');
      },
      (err) => {
        // alert('Update Failed');
        this.failureNotification('Update Failed');
      }
    );
  }

  /**
   * Upload user profile image
   * @param file the file object to be send to the api
   */
  handleProfileImageInput(file: FileList) {
    this.fileUpload = file.item(0);

    // Show the image preview
    if (this.fileUpload.type === 'image/jpeg' || this.fileUpload.type === 'image/png' || this.fileUpload.type === 'image/jpg') {
      if (this.fileUpload.size < 1048576) {
        // Show the image preview
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.userProfileImageURL = event.target.result;
        }

        reader.readAsDataURL(this.fileUpload);
        this.isDisableUploadButton = false;
      }
      else {
        this.failureNotification("Please do not upload profile image file greater than 1MB");
        this.isDisableUploadButton = true;
      }
    }
    else {
      this.failureNotification("Please upload the profile image in the following formats: .png, .jpeg, .jpg");
      this.isDisableUploadButton = true;
    }
  }

  /**
  * Upload user profile image
  * @param image the file object to be send to the api
  */
  uploadUserProfileImage(image) {

    let formData = new FormData();
    formData.append("filesData", this.fileUpload);

    this.userService.uploadUserProfileImage(this.targetUserEmaiId, formData).subscribe(
      (data: any) => {
        if (data != null) {
          this.successNotification(data.message);
          this.isDisableUploadButton = true;
          image.value = null;
        }
        else {
          this.failureNotification("Profile image upload failed.");
        }
      },

      (err) => {
        console.log(err);
      });
  }

  /**
   * Fetch User Profile Image
   * @param userEmailId the userEmailId to be send to the api
   */
  fetchUserProfileImage(userEmailId: string) {
    this.userService.fetchUserProfileImage(userEmailId).subscribe((userImage) => {
      if (userImage != null) {
        this.userProfileImageURL = 'data:image/png;base64,' + userImage;
      }
      else {
        this.userProfileImageURL = 'assets/img/userDefault.png';
      }

    },
      (err) => {
        console.log(err);
      });
  }
  /**
     * Delete User Profile Image
     */
  deleteUserProfileImage() {
    this.userService.deleteUserProfileImage(this.targetUserEmaiId).subscribe((isDeleted) => {
      if (isDeleted) {
        this.userProfileImageURL = 'assets/img/userDefault.png';
        this.isProfileImageDelete = false;
        this.successNotification("Image deleted successfully.");
      }
      else {
        this.failureNotification("Profile image delete failed.");
      }
    },
      (err) => {
        console.log(err);
      });
  }

  /**
   * Enable Edit Profile Image
   */
  enableEditProfileImage() {
    this.isProfileImageDelete = false;
    this.isProfileImageEdit = !this.isProfileImageEdit;
  }

  /**
  * Enable Delete Profile Image
  */
  enableDeleteProfileImage() {
    this.isProfileImageEdit = false;
    this.isProfileImageDelete = !this.isProfileImageDelete;
  }

  successNotification(message) {
    this.isShowNotificationSuccess = true;
    this.showSuccessMessage = message;
    setTimeout(() => {
      this.isShowNotificationSuccess = false;
    }, 5000);
  }

  failureNotification(message) {
    this.isShowNotificationFailure = true;
    this.showFailureMessage = message;
    setTimeout(() => {
      this.isShowNotificationFailure = false;
    }, 5000);
  }

  alertNotification(message){
    this.isShowNotificationAlert = true;
    this.showAlertMessage = message;
    setInterval(()=>{
      this.isShowNotificationAlert = false;
    },5000)
  }
}

